import React, { useState } from "react";
import MonthlyRevenue from "./Revenue Graphs/barchartMon";
import WeeklyRevenuePaiChart from "./Revenue Graphs/paichart";
import Footer from "../../Components/Footer/footer";
import StepGraph from "./Revenue Graphs/stepGraph";
import Barchart from "./Revenue Graphs/barchart";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import performRequest from "../../api/request";
import { useEffect } from "react";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import TransferLeadChart from "./Revenue Graphs/transferLeadChart";
import CallTrackingChart from "./Revenue Graphs/callTrackingChart";
import StartEndDateRevenue from "./Revenue Graphs/startendDateRevGraph";
import StartEndDateLeadsByOrigin from "./Revenue Graphs/leadsGraph";

function Allgraphs() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/allTablesCount/getCurrentWeekCounts")
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.currentWeek);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  function getCurrentWeekLabel() {
    const now = new Date();

    // Get the first day of the current month
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

    // Get current date and day of the month
    const dayOfMonth = now.getDate();

    // Calculate week number (0-based, so add 1)
    const weekNumber = Math.ceil((dayOfMonth + firstDayOfMonth.getDay()) / 7);

    // Get month name (e.g., "May")
    const monthName = now.toLocaleString("default", { month: "long" });

    return `${monthName}-Week ${weekNumber}`;
  }

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="container">
      <h1
        className="text-center mt-5 hero-title display-5 fw-bold"
        style={{ fontSize: "30px" }}
      >
        SALES ANALYTICS
      </h1>

      <hr></hr>
      <h1 className="text-center hero-title display-5 fw-bold">
        {getCurrentWeekLabel().toLocaleUpperCase()}
      </h1>
      <h1 className="text-center">WEEKLY REVENUE OVERVIEW</h1>
      <div className="row row-deck">
        <div className="col-12 col-md-3 col-lg-3">
          <div className="card bg-primary-lt card-sm">
            <div className="card-body">
              <div className="">
                <h1 className="text-center hero-title display-5 fw-bold ">
                  {data?.uniqueQuotation}
                </h1>
                <div className="fw-bold fs-1 text-center">
                  {" "}
                  UNIQUE QUOTATIONS
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3 col-lg-3">
          <div className="card bg-primary-lt card-sm">
            <div className="card-body">
              <div className="">
                <h1 className="text-center hero-title display-5 fw-bold ">
                  {data?.quotations}
                </h1>
                <div className="fw-bold fs-1 text-center">QUOTATIONS</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3 col-lg-3">
          <div className="card bg-primary-lt card-sm">
            <div className="card-body">
              <div className="">
                <h1 className="text-center hero-title display-5 fw-bold ">
                  {data?.siteInspections}
                </h1>
                <div className="fw-bold fs-1 text-center">SITE INSPECTIONS</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3 col-lg-3">
          <div className="card bg-primary-lt card-sm">
            <div className="card-body">
              <div className="">
                <h1 className="text-center hero-title display-5 fw-bold ">
                  {data?.leads}
                </h1>
                <div className="fw-bold fs-1 text-center">LEADS</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr></hr>
      <p className="text-center fs-1">
        This feature indicates the weekly revenue generated by each product. It
        calculates the total earnings for every product over the course of a
        week and displays the data in a graph, helping users visually analyze
        product performance and identify sales trends.
      </p>
      <div>
        <StepGraph />
      </div>
      <hr></hr>
      <h1 className="text-center">Revenue Overview by Date Range</h1>
      <hr />
      <p className="text-center fs-1">
        This feature displays the revenue generated by each product within a
        selected start and end date. It calculates the total earnings for every
        product during the chosen time period and presents the data in a
        graphical format, enabling users to analyze product performance and
        identify revenue trends across a specific date range.
      </p>
      <div>
        <StartEndDateRevenue></StartEndDateRevenue>
      </div>
      <hr></hr>
      <h1 className="text-center">Monthly Revenue Overview</h1>
      <hr></hr>
      <p className="text-center fs-1">
        This feature indicates the Monthly revenue generated by each product. It
        calculates the total earnings for every product over the course of a
        month and displays the data in a graph, helping users visually analyze
        product performance and identify sales trends.
      </p>
      <div>
        <MonthlyRevenue></MonthlyRevenue>
      </div>
      <hr></hr>
      <h1 className="text-center">Leads Overview</h1>
      <hr></hr>
      <p className="text-center fs-1">
    This feature displays the <strong>marketing leads</strong> generated over a 
    selected date range. It counts all leads captured between the chosen start 
    and end dates and visualizes the data in a graph, helping users track lead 
    sources, analyze trends, and understand marketing performance during that period.
  </p>
      <div>
        <StartEndDateLeadsByOrigin/>
      </div>
      <hr></hr>
      <div>
        <WeeklyRevenuePaiChart />
      </div>
      <hr></hr>
      <div>
        <Barchart />
      </div>

      <hr></hr>
      <h1 className="text-center">Call Tracking Overview</h1>
      <hr></hr>
      <CallTrackingChart />
      <hr></hr>
      <h1 className="text-center">Lead Transfer Overview</h1>
      <hr></hr>
      <TransferLeadChart />
      <Footer />
    </div>
  );
}

export default Allgraphs;
